import { render, staticRenderFns } from "./GroupGreeter.vue?vue&type=template&id=15bc32a2&scoped=true&"
import script from "./GroupGreeter.vue?vue&type=script&lang=js&"
export * from "./GroupGreeter.vue?vue&type=script&lang=js&"
import style0 from "./GroupGreeter.vue?vue&type=style&index=0&id=15bc32a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc32a2",
  null
  
)

export default component.exports